/**
 * Helper function to get the hover color for a given base color using oklch color space
 * @param color - The base color to get the hover color for
 * @param amount - The amount to adjust the color by, defaults to -12.5%
 * @returns The hover color, darkened by the amount
 *
 * @source More on oklch → https://evilmartians.com/chronicles/oklch-in-css-why-quit-rgb-hsl
 */
export function getHoverColor({
  color,
  amount = -0.125,
}: {
  color: string;
  amount?: number;
}) {
  return `oklch(from ${color} calc(l + ${amount}) c h)`;
}
